import Vue from 'vue'
import ToastedPlugin from 'vue-toasted'

Vue.use(ToastedPlugin, {
  containerClass: 'toasted-container--custom',
})
